export const AD_SEGMENTS = [
  { value: "DOCTORS", label: "Médicos" },
  { value: "DENTISTS", label: "Dentistas" },
  { value: "CAREGIVERS", label: "Cuidadores" },
  { value: "HEALTH_PLUS", label: "Saúde+" },
] as const;

export type AdSegment = (typeof AD_SEGMENTS)[number]["value"];

export function getAdSegmentLabel(segment: AdSegment | null): string {
  return AD_SEGMENTS.find((option) => option.value === segment)?.label ?? "Não classificado";
}
